import dayjs from 'dayjs'

export enum ChartType {
  GPUCore = 1,
  GPURAM = 2,
  CPU = 3,
  Memory = 4,
  Disk = 5,
  Bandwidth = 6,
}

export function enumToChartType(num: number): ChartType {
  switch (num) {
    case 1:
      return ChartType.GPUCore
    case 2:
      return ChartType.GPURAM
    case 3:
      return ChartType.CPU
    case 4:
      return ChartType.Memory
    case 5:
      return ChartType.Disk
    case 6:
      return ChartType.Bandwidth
    default:
      throw new Error(`Invalid chart type: ${num}`)
  }
}

export const extractTimePoints = (items: any[]) => {
  const allTimePoints = new Array<dayjs.Dayjs>()
  items.forEach((item) => {
    const matrixArray = item.result[0]?.matrixArray || []
    if (Array.isArray(matrixArray) && matrixArray.length > 0) {
      matrixArray.forEach((v: any) => {
        const time = dayjs(v?.matrix?.[0] * 1000)
        allTimePoints.push(time)
      })
      return allTimePoints
    }
  })
  return allTimePoints
}
